import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from './app.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
   providedIn: 'root',
})
export class TemplateService {
   constructor(
      private http: HttpClient,
      private appService: AppService,
   ) {}

   getDocumentTemplates(caseKind: any) {
      return this.http.get(this.appService.getDocManagerUrl() + environment.documentTemplatesUrl + caseKind) as Observable<any>;
   }

   getAllDocumentTemplates() {
      return this.http.get(this.appService.getDocManagerUrl() + environment.documentTemplatesFindAll) as Observable<any>;
   }

   addDocumentTemplate(file: File, docType: string) {
      const formData: FormData = new FormData();
      formData.append('file', file);
      formData.append('docType', docType);
      return this.http.post(this.appService.getDocManagerUrl() + environment.documentTemplatesAdd, formData, { responseType: 'text' }) as Observable<any>;
   }

   deleteDocumentTemplate(documentKeyName: string) {
      return this.http.put(this.appService.getDocManagerUrl() + environment.documentTemplatesDelete, documentKeyName) as Observable<any>;
   }

   editTemplateProperty(body: any) {
      return this.http.put(this.appService.getDocManagerUrl() + environment.documentTemplatesEdit, body) as Observable<any>;
   }
}
